"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerPadding = exports.MinWidth = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var enums_1 = require("./enums");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_common_1 = require("@ryerson/frontend.common");

var polished_1 = require("polished");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var enums_2 = require("./enums");

var frontend_common_2 = require("@ryerson/frontend.common");

var react_2 = require("@emotion/react");

var MinWidth;

(function (MinWidth) {
  MinWidth["sm"] = "50px";
  MinWidth["md"] = "100px";
  MinWidth["lg"] = "100px";
  MinWidth["xl"] = "120px";
})(MinWidth || (exports.MinWidth = MinWidth = {}));

var InnerPadding;

(function (InnerPadding) {
  InnerPadding["sm"] = "30px";
  InnerPadding["md"] = "40px";
  InnerPadding["lg"] = "40px";
  InnerPadding["xl"] = "50px";
})(InnerPadding || (exports.InnerPadding = InnerPadding = {}));

var ErrorContainer = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tmargin-top: 10px;\n\tmargin-bottom: 8px;\n"])));
var DropDownContainer = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tbox-sizing: border-box;\n\t", "\n"])), function (props) {
  var fontSize = props.fontSize,
      selectFontSize = props.selectFontSize,
      size = props.size,
      InnerPadding = props.InnerPadding,
      disabled = props.disabled,
      theme = props.theme,
      type = props.type,
      InputPadding = props.InputPadding,
      borderRadius = props.borderRadius,
      InputHeight = props.InputHeight,
      valid = props.valid,
      borderColor = props.borderColor,
      customPadding = props.customPadding;
  var color = theme.colors.primary.gray;
  var rgbColorObject = (0, polished_1.parseToRgb)(color);
  var rgbColor = "rgb(".concat(rgbColorObject.red, ",").concat(rgbColorObject.green, ",").concat(rgbColorObject.blue, ")");
  var chevronDownSvg = "data:image/svg+xml;utf-8,<svg width=\"10\" height=\"11.42\" aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"chevron-down\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><path style=\"fill: ".concat(rgbColor, "\" d=\"M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z\"></path></svg>");
  return (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\tfont-size: ", ";\n\t\t\tselect {\n\t\t\t\tappearance: none; // need to include browser extensions for this attribute\n\t\t\t\tbackground-color: transparent;\n\t\t\t\tborder: none;\n\t\t\t\tpadding: 0 ", " 0 0;\n\t\t\t\tmargin: 0;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tfont-family: inherit;\n\t\t\t\tfont-size: ", ";\n\t\t\t\tcursor: inherit;\n\t\t\t\tline-height: inherit;\n\t\t\t\tz-index: 1;\n\t\t\t\t&::-ms-expand {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t\tcolor: ", ";\n\t\t\t\toutline: none;\n\t\t\t\tbackground: url(", ") calc(100% - ", ") 50%\n\t\t\t\t\tno-repeat #fff;\n\t\t\t\tborder-radius: ", ";\n\t\t\t\tbackground-color: ", ";\n\n\t\t\t\t@media only screen and (max-width: ", ") {\n\t\t\t\t\tbackground-position: calc(\n\t\t\t\t\t\t100% - ", "\n\t\t\t\t\t);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.select-wrapper {\n\t\t\t\tdisplay: block;\n\t\t\t\talign-items: center;\n\t\t\t\tposition: relative;\n\t\t\t\theight: ", ";\n\t\t\t\tpadding: 0 0 0 ", ";\n\t\t\t\twidth: 100%;\n\t\t\t\tborder: 1px solid\n\t\t\t\t\t", ";\n\t\t\t\t&:focus-within {\n\t\t\t\t\tborder: 1px solid ", ";\n\t\t\t\t}\n\t\t\t\tborder-radius: ", ";\n\t\t\t\tcursor: ", ";\n\t\t\t\tbackground-color: ", ";\n\t\t\t\t&:not(.select--multiple)::after {\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\tjustify-self: end;\n\t\t\t\t\twidth: 0.8em;\n\t\t\t\t\theight: 0.5em;\n\t\t\t\t\tbackground-color: ", ";\n\t\t\t\t\tclip-path: polygon(100% 0%, 0 0%, 50% 100%);\n\t\t\t\t}\n\t\t\t\t@media only screen and (max-width: ", "px) {\n\t\t\t\t\theight: ", ";\n\t\t\t\t\tpadding-left: ", ";\n\t\t\t\t}\n\t\t\t}\n\t\t"])), fontSize, customPadding ? customPadding + "px" : InnerPadding[size], selectFontSize, color, "'".concat(chevronDownSvg, "'"), InputPadding[size], borderRadius, disabled ? theme.colors.primary.lighterGray : theme.colors.primary.white, theme.breakpoints.lg, customPadding ? customPadding + "px" : "20px", InputHeight[size], customPadding ? customPadding + "px" : InputPadding[size], !valid ? (0, polished_1.mix)(0.4, theme.colors.primary.error, theme.colors.primary.white) : borderColor, theme.colors[type].selected, borderRadius, disabled ? "default" : "pointer", disabled ? theme.colors.primary.lighterGray : theme.colors.primary.white, borderColor, parseInt(theme.breakpoints.lg) - 1, enums_2.InputMobileHeight[size], customPadding ? customPadding + "px" : InputPadding[size]);
});
var Label = styled_1.default.label(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t", "\n"])), function (props) {
  var fontSize = props.fontSize,
      labelColor = props.labelColor;
  return (0, react_2.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\t\tdisplay: block;\n\t\t\tfont-size: ", ";\n\t\t\tcolor: ", ";\n\t\t\tmargin-right: 10px;\n\t\t"])), fontSize, labelColor);
});
var LabelContainer = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t", "\n"])), function (props) {
  var marginBottom = props.marginBottom;
  return (0, react_2.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t\tmargin-bottom: ", ";\n\t\t"])), marginBottom);
});

var Dropdown = function Dropdown(_ref) {
  var id = _ref.id,
      className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      value = _ref.value,
      name = _ref.name,
      options = _ref.options,
      label = _ref.label,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onDropdownOpen = _ref.onDropdownOpen,
      dataTestId = _ref.dataTestId,
      _ref$shape = _ref.shape,
      shape = _ref$shape === void 0 ? "square" : _ref$shape,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      inputRef = _ref.inputRef,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? true : _ref$isValid,
      _ref$submitted = _ref.submitted,
      submitted = _ref$submitted === void 0 ? true : _ref$submitted,
      validation = _ref.validation,
      labelAddition = _ref.labelAddition,
      sizeMobile = _ref.sizeMobile,
      customPadding = _ref.customPadding,
      autoComplete = _ref.autoComplete;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      white = _theme$colors$primary.white,
      lightGray = _theme$colors$primary.lightGray,
      errorColor = _theme$colors$primary.error; // mobile size adjustment

  var _ref3 = (0, frontend_common_2.useWindowSize)(),
      _ref4 = _slicedToArray(_ref3, 1),
      width = _ref4[0];

  var isMobile = width < parseInt(theme.breakpoints.lg);
  sizeMobile && isMobile && (size = sizeMobile);
  var selectFontSize = isMobile ? theme.typography.fonts.sizes.sm.size : theme.typography.fonts.sizes.md.size;
  var fontSize = theme.typography.fonts.sizes.md.size;

  var _react_1$default$useS = react_1.default.useState(),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      error = _react_1$default$useS2[0],
      setError = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(isValid),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      valid = _react_1$default$useS4[0],
      setValid = _react_1$default$useS4[1];

  var labelColor = disabled ? theme.colors[type].disable : theme.colors[type].label;
  var borderColor = (0, polished_1.rgba)(lightGray, 0.8);
  var borderRadiusRound = "42px";
  var borderRadiusSquare = "2px";
  var isLabelAdditionString = typeof labelAddition === "string";
  var borderRadius = shape === "rounded" ? borderRadiusRound : borderRadiusSquare;
  react_1.default.useEffect(function () {
    required && setError((0, frontend_common_1.validateRequired)(value));
    setValid(isValid);
  }, [isValid]);
  react_1.default.useEffect(function () {
    required && submitted && !isValid && value && validation && setError(validation(value));
  }, [isValid, submitted]);

  var _ref5 = (0, react_1.useState)(false),
      _ref6 = _slicedToArray(_ref5, 2),
      focused = _ref6[0],
      setFocused = _ref6[1];
  /**
   * tbn: there’s no actual «onDropdownClose» HTML action,
   * there’s only «onBlur» and «onChange».
   * Any existing work-arounds are unreliable and browser-specific hacks at best.
   */


  function handleCloseDropdown() {
    if (focused) {
      setFocused(false);
      !!onDropdownOpen && onDropdownOpen(false);
    }
  }

  var handleOnChange = function handleOnChange(event) {
    handleCloseDropdown();
    onChange(event.target.value);
  };

  var handleFocus = function handleFocus(value) {
    !!onDropdownOpen && onDropdownOpen(true);
    setFocused(true);
    onFocus && onFocus(value);
  };

  var handleBlur = function handleBlur(value) {
    handleCloseDropdown();
    submitted && validateDropdown(value);
    onBlur && onBlur(value);
  };

  var validateDropdown = function validateDropdown(value) {
    if (validation) {
      var result = validation(value);
      setError(result);
      setValid(!result);
    }
  };

  return (0, jsx_runtime_1.jsxs)(DropDownContainer, {
    className: "drop-down-root ".concat(size),
    fontSize: fontSize,
    selectFontSize: selectFontSize,
    size: size,
    InnerPadding: InnerPadding,
    disabled: disabled,
    theme: theme,
    type: type,
    InputPadding: enums_1.InputPadding,
    borderRadius: borderRadius,
    InputHeight: enums_1.InputHeight,
    valid: valid,
    borderColor: borderColor,
    customPadding: customPadding,
    children: [(label || labelAddition) && (0, jsx_runtime_1.jsxs)(LabelContainer, {
      direction: isLabelAdditionString ? "column" : "row",
      alignItems: isLabelAdditionString ? "flex-start" : "center",
      marginBottom: enums_1.LabelBottomMargin[size],
      children: [label && (0, jsx_runtime_1.jsxs)(Label, {
        tabIndex: -1,
        htmlFor: id,
        fontSize: fontSize,
        labelColor: labelColor,
        children: [label, required && (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          color: errorColor,
          children: " *"
        })]
      }), labelAddition && (isLabelAdditionString ? (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        type: type,
        size: fontSize,
        children: labelAddition
      }) : labelAddition)]
    }), (0, jsx_runtime_1.jsx)("div", {
      className: "select-wrapper",
      tabIndex: -1,
      children: (0, jsx_runtime_1.jsx)("select", {
        id: id,
        className: className,
        name: name,
        required: required,
        disabled: disabled,
        onChange: handleOnChange,
        onFocus: function onFocus(event) {
          return handleFocus(event.target.value);
        },
        onBlur: function onBlur(event) {
          return handleBlur(event.target.value);
        },
        value: value,
        "data-testid": dataTestId,
        tabIndex: 0,
        ref: inputRef,
        autoComplete: autoComplete,
        "aria-disabled": disabled ? true : false,
        children: options.map(function (item) {
          return (0, jsx_runtime_1.jsx)("option", {
            value: item.value,
            disabled: item.disabled || false,
            children: item.display || item.value
          }, item.value);
        })
      })
    }), !valid && (0, jsx_runtime_1.jsx)(ErrorContainer, {
      children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "md",
        color: type !== "tertiary" ? errorColor : (0, polished_1.mix)(0.2, errorColor, white),
        children: error
      })
    })]
  });
};

Dropdown.displayName = "Dropdown";
exports.default = Dropdown;